import { render, staticRenderFns } from "./dayClassDuration.vue?vue&type=template&id=812e6df6&scoped=true"
import script from "./dayClassDuration.vue?vue&type=script&lang=js"
export * from "./dayClassDuration.vue?vue&type=script&lang=js"
import style0 from "./dayClassDuration.vue?vue&type=style&index=0&id=812e6df6&prod&lang=scss&scoped=true"
import style1 from "./dayClassDuration.vue?vue&type=style&index=1&id=812e6df6&prod&lang=less"
import style2 from "./dayClassDuration.vue?vue&type=style&index=2&id=812e6df6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17.21_prettier@2.8.8_vue-temp_pgqv4bjfw4n43uthtcnbh5tcie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812e6df6",
  null
  
)

export default component.exports